import ManualQuote from "../components/ManualQoute";

const ManualQuoteManagement = ()=>{
    return <ManualQuote/>

}
export default ManualQuoteManagement;